(function () {
  var header = document.querySelector("[data-pa-header]");
  var menu = document.querySelector("[data-menu]");
  var openMenu = document.querySelector("[data-menu-open]");
  var closeMenu = document.querySelector("[data-menu-close]");
  var searchPanel = document.querySelector("[data-inline-search]");
  var searchToggle = document.querySelector("[data-search-toggle]");
  var closeSearch = document.querySelector("[data-search-close]");
  var searchInput = document.querySelector("[data-inline-search-input]");

  document.documentElement.classList.remove("no-js");

  function setHeaderState() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 12);
  }

  function setSearch(open) {
    if (!searchPanel || !searchToggle) return;
    searchPanel.hidden = !open;
    searchPanel.setAttribute("aria-hidden", open ? "false" : "true");
    searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (header) header.classList.toggle("is-search-open", open);

    if (open && searchInput) {
      requestAnimationFrame(function () {
        searchInput.focus();
      });
    }
  }

  function setMenu(open) {
    if (!menu || !openMenu) return;
    if (open) setSearch(false);
    menu.classList.toggle("is-open", open);
    menu.setAttribute("aria-hidden", open ? "false" : "true");
    openMenu.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.classList.toggle("pa-menu-open", open);
  }

  function animateDetails(details) {
    var body = details.querySelector(".menu-dropdown-body");
    if (!body) return;

    if (details.open) {
      body.style.height = "0px";
      body.style.opacity = "0";
      body.style.visibility = "visible";
      requestAnimationFrame(function () {
        body.style.transition =
          "height 520ms cubic-bezier(0.22, 1, 0.36, 1), opacity 320ms ease, transform 420ms cubic-bezier(0.22, 1, 0.36, 1)";
        body.style.height = body.scrollHeight + "px";
        body.style.opacity = "1";
        body.style.transform = "translateY(0)";
      });
      window.setTimeout(function () {
        if (details.open) body.style.height = "auto";
      }, 540);
    } else {
      body.style.height = body.scrollHeight + "px";
      requestAnimationFrame(function () {
        body.style.transition =
          "height 440ms cubic-bezier(0.22, 1, 0.36, 1), opacity 260ms ease, transform 360ms cubic-bezier(0.22, 1, 0.36, 1)";
        body.style.height = "0px";
        body.style.opacity = "0";
        body.style.transform = "translateY(-8px)";
      });
      window.setTimeout(function () {
        if (!details.open) body.style.visibility = "hidden";
      }, 460);
    }
  }

  if (openMenu) {
    openMenu.addEventListener("click", function () {
      setMenu(true);
    });
  }

  if (closeMenu) {
    closeMenu.addEventListener("click", function () {
      setMenu(false);
    });
  }

  if (searchToggle) {
    searchToggle.addEventListener("click", function () {
      if (menu && menu.classList.contains("is-open")) setMenu(false);
      setSearch(searchPanel ? searchPanel.hidden : false);
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener("click", function () {
      setSearch(false);
      searchToggle.focus();
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      setMenu(false);
      setSearch(false);
    }
  });

  document.addEventListener("click", function (event) {
    if (!menu || !menu.classList.contains("is-open")) return;
    if (menu.contains(event.target) || (openMenu && openMenu.contains(event.target))) return;
    setMenu(false);
  });

  document.addEventListener("click", function (event) {
    if (!searchPanel || searchPanel.hidden) return;
    if (searchPanel.contains(event.target) || (searchToggle && searchToggle.contains(event.target))) return;
    setSearch(false);
  });

  document.querySelectorAll(".menu-dropdown").forEach(function (details) {
    details.addEventListener("toggle", function () {
      animateDetails(details);
    });
  });

  if ("IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px" }
    );

    document.querySelectorAll(".reveal").forEach(function (element) {
      revealObserver.observe(element);
    });
  } else {
    document.querySelectorAll(".reveal").forEach(function (element) {
      element.classList.add("is-visible");
    });
  }

  setHeaderState();
  window.addEventListener("scroll", setHeaderState, { passive: true });
})();
